<div class="dropdown" [ngClass]="{ 'show': dropdownOpen }" (click)="toggleDropdown()">
  <input type="text" [value]="selectedOption" readonly placeholder="{{ 'clickHere' | translate }}">
  <div class="dropdown-content">
    <a href="#" *ngFor="let option of options" (click)="selectOption(option, $event)">{{ option }}</a>
  </div>
</div>
